import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 → flat canonical /hvac-marketing-parker
export const Route = createFileRoute("/hvac/parker")({
  beforeLoad: () => {
    throw redirect({ to: "/hvac-marketing-parker", statusCode: 301 });
  },
  component: () => null,
});
